module.exports = __webpack_public_path__ + "static/media/JPBA01.8b2dd796.jpg";